import { Box } from '@mui/material';
import { styled } from '@mui/material/styles';

export const StyledAppList = styled(Box)`
  margin: 16px;
`;
